import { MapPinOff, X, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

// In-app guidance shown when a photo can't be geotagged (e.g. iPad Location Services off).
export function LocationHelp({ code, onRetry, onClose, retrying }) {
  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/70 p-4" data-testid="location-help">
      <div className="w-full max-w-sm rounded-xl bg-white p-5 shadow-2xl">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2 text-slate-900">
            <MapPinOff className="h-5 w-5 text-red-600" />
            <h3 className="font-heading text-base font-bold">Location not available</h3>
          </div>
          {onClose && (
            <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="location-help-close"><X className="h-4 w-4" /></button>
          )}
        </div>
        <p className="mt-2 text-sm text-slate-600">Photos won&apos;t be geotagged and the map can&apos;t pin the property until location is enabled.</p>
        <div className="mt-3 rounded-md bg-slate-50 p-3 text-sm text-slate-700">
          <p className="font-bold text-slate-800">On iPad / iPhone:</p>
          <ol className="mt-1 list-decimal space-y-1 pl-4">
            <li>Open <strong>Settings → Privacy &amp; Security → Location Services</strong> and turn it <strong>ON</strong>.</li>
            <li>Scroll to <strong>Safari Websites</strong> → set to <strong>While Using the App</strong>.</li>
            <li>Return here and tap <strong>Try again</strong>, then choose <strong>Allow</strong> when prompted.</li>
          </ol>
          <p className="mt-2 text-xs text-slate-500">If RetroTrack was added to the Home Screen, open it in <strong>Safari</strong> instead — Home-Screen apps can block location.</p>
        </div>
        <Button type="button" onClick={onRetry} disabled={retrying} className="mt-4 w-full bg-accent font-bold hover:bg-accent/90" data-testid="location-help-retry">
          <RefreshCw className={`mr-2 h-4 w-4 ${retrying ? "animate-spin" : ""}`} /> {retrying ? "Getting location…" : "Try again"}
        </Button>
      </div>
    </div>
  );
}
